<template>
  <div class="app-container">
    <!-- 面包屑 -->
    <div class="crumbsBg">
      <div class="container">
        <div class="crumbs">
          <a class="active" href="/">首页</a>
          <a class="active" :href="`/news/news-list?type=${info.newsTypeId}`">{{ info.newsTypeName }}</a>
          <span>{{ info.newsTypeName }}详情</span>
        </div>
      </div>
    </div>
    <!-- 面包屑 -->

    <div class="container">
      <div class="row newsListShow">
        <div class="col-md-12">
          <div class="newsInfoArea">
            <div class="title">
              {{ info.newsTitle }}
            </div>
            <div class="share">
              <div class="resources">
                <span>{{ info.newsSource }}</span>
                <span>{{ info.publishTime | formatDate }}</span>
                <span><i class="ivu-icon ivu-icon-ios-eye-outline"></i>{{ info.clickCount }}（阅读）</span>
              </div>
              <div id="shareIcon">
                <!--                <share type="news" :share-data="{id: info.id, type: info.newsTypeId}" />-->
              </div>
            </div>
            <div class="clear"></div>
            <div class="desc">
              {{ info.newsSecondTitle | subString(0, 150) }}...
            </div>
            <div id="content" class="content" v-html="info.contentHtml">
            </div>
            <div class="bottomClickTag">
              <span class="tags">
                <a v-for="tag in info.tags.split(',')" class="tag"># {{ tag }}#</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsApi } from '@/api/news';
import appCode from '@/assets/image/common/code-app.png';

export default {
  name: 'NewsInfo',
  layout: 'news',
  components: {},
  filters: {
    // 截取指定位数
    subString (string, start, end) {
      return string.substring(start, end);
    },
    // 返回年月日
    formatDate (string, state) {
      if (state == 'dateMonth') {
        return string.substring(5, 10);
      }
      if (state == 'dateMonthTwo') {
        return string.substring(5, 10).replace(/-/g, '/');
      }
      if (state == 'dateMonthTime') {
        return string.substring(5, 19).replace(/-/g, '/');
      }
      if (state == 'dateHour') {
        const newHour = string.substring(11, 16).split(':');
        let hour = newHour[0];
        let minute = newHour[1];
        if (hour.length == 1) {
          hour = '0' + hour;
        }
        if (minute.length == 1) {
          minute = '0' + minute;
        }
        return hour + ':' + minute;
      }
      if (state == 'dateYear') {
        const newData = string.substring(0, 10).split('-');
        return newData[0] + '年' + newData[1] + '月' + newData[2] + '日';
      }
      if (string) {
        return string.substring(0, 10).replace(/-/g, '/');
      } else {
        return '';
      }
    }
  },
  props: {},
  async asyncData ({ app, query }) {
    const detailResult = await newsApi.getNewsDetail(query.newsId);
    return {
      info: detailResult.data
    };
  },
  data () {
    return {
      appCode,
    };
  },
  mounted () {

  },
  methods: {
    loadMore () {

    },
    likeAdd () {

    }
  },
  head () {
    return {};
  }
};
</script>
<style lang='less' scoped>
@import "../../assets/style/news/news-base";

.app-container {
  background-color: white;
}

.newsInfoArea {
  margin-right: 30px;
  margin-bottom: 30px;

  .title {
    .FSize(20);
    .fb;
    color: @black;
    margin-bottom: 35px;
    text-align: center;
  }

  .share {
    height: 32px;
    .rel;
    display: flex;
    justify-content: flex-end;

    .resources {
      .fl();
      height: 32px;
      line-height: 32px;
      .FSize(14);
      color: @gray;
      .flex;

      span {
        margin-right: 20px;

        img {
          .rel;
          top: -1px;
        }
      }

      .icon {
        .FSize(16);
        margin-right: 5px;

        &.icon-zan {
          color: #ff1e1e;
        }
      }
    }

    .shareIcon {
      .fr();
      height: 32px;
      line-height: 32px;
      margin-bottom: 30px;
      right: 0;
    }
  }

  .desc {
    background: #FBFBFB;
    padding: 18px 50px;
    .FSize(16);
    color: @gray;
    margin-top: 20px;
  }

  .content {
    margin-top: 30px;
    //background: url("~@/assets/image/watermark.png");
    .describetion {
      padding: 15px 50px;
      background: #fbfbfb;
      .FSize(16);
      line-height: 32px;
      height: 94px;
      overflow: hidden;
      color: @gray;
    }

    /deep/ ol li {
      list-style-type: decimal;
      list-style-position: inside;
    }

    p {
      .FSize(16);
      color: @black;
      padding-top: 30px;
      line-height: 28px;
      background-color: transparent !important;

      img:last-child {
        margin: 0 !important;
      }
    ;
    }

    img {
      .block;
      width: 100%;
    }
  }

  .bottomClickTag {
    padding-top: 20px;
    height: 52px;

    .click {
      .fl();
      line-height: 32px;
      height: 32px;
      .FSize(14);
      color: @gray;
      .flex;
    }

    .tags {
      a {
        margin-right: 20px;
        .fr();
        color: @main-color;
        .FSize(16);
      }
    }
  }
}

@keyframes zanAction {
  0% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}

.icon-zan {
  color: @redA100;
  animation: zanAction 1s;
}

.icon-zan-outline {
  color: @gray;
}

.hitClick {
  cursor: pointer;
}

.zanClick {
  background: #f2f3f6;
  .radius(50%);
  .inlineFlex;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.memberHeader .memberHeaderCon {
  height: 70px;
}

.newsListShow .siteInfo .moreList {
  h3 {
    .rel;

    &:before {
      content: '';
      .inline;
      width: 2px;
      height: 16px;
      background: @green;
      margin-right: 10px;
    }
  }

  ul {
    li {
      .block;
      height: auto;
      line-height: 30px;

      a {
        .block;
        .FSize(16);
        white-space: inherit;

        &:hover {
          .fb;
          .opacity(1);
        }
      }
    }
  }
}

.newsListShow {
  .keyTitle {
    height: 24px;
    line-height: 24px;
    .FSize(16);
    color: @gray;
    margin: 30px 0 10px;

    span {
      .FSize(24);
      .fb;
      color: @green;
    }
  }

  .siteInfo {
    .moreBanner {
      .block;
      margin: 47px 0 -10px;
    }

    .moreList, .scavengingArea, .siteTxtInfo {
      background: #fbfbfb;
    }

    .moreList {
      padding: 20px;
      margin-top: 30px;

      .moreListImg {
        background: @greenA100;
        color: @white;
        .rel;
        .textCenter;

        span {
          font-size: 120px;
          .fb;
          color: rgba(255, 255, 255, 0.06);
        }

        b {
          .abs;
          z-index: 1;
          font-size: 40px;
          .inline;
          width: 160px;
          height: 50px;
          line-height: 50px;
          top: 50%;
          left: 50%;
          margin-top: -25px;
          margin-left: -80px;
        }
      }

      h3 {
        .FSize(20);
        .fb;
        margin-top: 0;
      }

      ul {
        li {
          height: 40px;
          line-height: 40px;
          .FSize(14);
          .flex;

          a {
            flex: 1;
            .ellipsis;
          }

          .time {
            color: @gray;
            width: 55px;
            .textRight;
          }
        }
      }
    }

    .scavengingArea {
      padding: 30px 0 30px 30px;
      height: 160px;
      margin-bottom: 20px;
      .flex;

      .areaLeft {
        width: 100px;
        height: 100px;

        img {
          width: 100%;
          height: 100%;
          .block;
        }
      }

      .areaRight {
        flex: 1;
        .textCenter;

        img {
          .block;
          width: 240px;
          height: 40px;
          margin: 0 auto 30px;
        }

        span {
          .FSize(16);
          color: @orgA200;
        }
      }
    }

    .siteTxtInfo {
      padding: 20px;

      p {
        .FSize(14);
        color: @gray;
        line-height: 26px;
      }
    }
  }
}

</style>
